import React from "react";
import {CSSObject} from "@core-ui/react-stitch";
import {Transition} from "./Transition";
import {transitions} from "./transitions";
import {DrawerSlideProps, DrawerSlidePosition} from "./types";

export const slideTimeout = {
  enter: parseFloat(transitions.expressive.in.transitionDuration),
  exit: parseFloat(transitions.performance.out.transitionDuration),
};

export function DrawerSlide({
  children,
  in: slideIn,
  position = DrawerSlidePosition.left,
  slideCSS = {},
}: DrawerSlideProps): JSX.Element {
  const transitionCSS = slideIn
    ? transitions.expressive.in
    : transitions.performance.out;

  const translation = {
    [DrawerSlidePosition.left]: {transform: "translate(-100%, 0)"},
    [DrawerSlidePosition.right]: {transform: "translate(100%, 0)"},
    [DrawerSlidePosition.top]: {transform: "translate(0, -100%)"},
    [DrawerSlidePosition.bottom]: {transform: "translate(0, 100%)"},
  };

  const transitionStyles = {
    entering: {transform: "translate(0)"},
    entered: {transform: "translate(0)"},
    exiting: translation[position],
    exited: translation[position],
    unmounted: {},
  };

  const positionStyles: {[key in DrawerSlidePosition]: CSSObject} = {
    [DrawerSlidePosition.left]: {
      left: 0,
      height: "100%",
    },
    [DrawerSlidePosition.right]: {
      right: 0,
      height: "100%",
    },
    [DrawerSlidePosition.top]: {
      top: 0,
      width: "100%",
    },
    [DrawerSlidePosition.bottom]: {
      bottom: 0,
      width: "100%",
    },
  };

  const defaultStyles: CSSObject = {
    display: "flex",
    position: "fixed",
    alignSelf: "flex-start",
    flexDirection: "column",
    boxSizing: "border-box",
    transitionProperty: "transform",
    ...transitionCSS,
    ...positionStyles[position],
    ...slideCSS,
  };

  return (
    <Transition in={slideIn} timeout={slideTimeout}>
      {(transitionStatus) =>
        children({...defaultStyles, ...transitionStyles[transitionStatus]})
      }
    </Transition>
  );
}
